module.exports = __webpack_public_path__ + "static/media/matcap-porcelain-white.1b992319.jpg";